import React from "react";
import Watch from "./watch.svg";

function WatchIcon() {
  return <img src={Watch} alt="Watch Icon" />;
}

export default WatchIcon;
